// Static help-center content taken from the approved design (docs/صفحه اصلی دانش نامه  help page/help.html).
// Persian-only content; there is no CMS source for videos yet, so articles/videos/categories live here.

export const HELP_CATEGORIES = [
  {
    "id": "start",
    "title": "شروع کار با زوفینو",
    "desc": "ثبت‌نام، ساخت فضای کاری و دعوت اعضا",
    "icon": "rocket_launch"
  },
  {
    "id": "goals",
    "title": "اهداف",
    "desc": "ساخت هدف، شاخص نتیجه و هم‌راستایی تیم",
    "icon": "flag"
  },
  {
    "id": "projects",
    "title": "پروژه‌ها",
    "desc": "از ساخت پروژه تا مایلستون، برد و گزارش",
    "icon": "folder_open"
  },
  {
    "id": "tasks",
    "title": "کارها و تمرکز",
    "desc": "ساخت کار، تکرار، اولویت و تمرکز امروز",
    "icon": "task_alt"
  },
  {
    "id": "teams",
    "title": "تیم و اعضا",
    "desc": "دعوت، دسترسی، نقش و خروج همکار",
    "icon": "groups"
  },
  {
    "id": "messages",
    "title": "پیام‌ها و همکاری",
    "desc": "گفت‌وگو و اشتراک‌گذاری اطلاعات کاری",
    "icon": "chat"
  },
  {
    "id": "settings",
    "title": "تنظیمات",
    "desc": "فضای کاری، اعلان‌ها، اشتراک و امنیت",
    "icon": "settings"
  }
];

export const HELP_ARTICLES = [
  {
    "id": "create-workspace",
    "type": "article",
    "title": "ثبت‌نام و ساخت یک فضای کاری",
    "summary": "در چند دقیقه حساب زوفینو و اولین فضای کاری سازمانتان را بسازید.",
    "cat": "start",
    "time": "۶ دقیقه",
    "level": "مقدماتی",
    "popular": 98,
    "updated": "امروز",
    "keywords": "ورود ثبت نام سازمان فضای کاری workspace شماره موبایل",
    "sections": [
      "ساخت حساب کاربری",
      "ایجاد فضای کاری",
      "انتخاب نام و حوزه",
      "دعوت اولین همکار"
    ]
  },
  {
    "id": "goal-project",
    "type": "article",
    "title": "تفاوت هدف و پروژه چیست؟",
    "summary": "با یک شاقول ساده تشخیص دهید چیزی که نوشته‌اید هدف است یا پروژه.",
    "cat": "goals",
    "time": "۵ دقیقه",
    "level": "مقدماتی",
    "popular": 95,
    "updated": "۲ روز پیش",
    "keywords": "هدف پروژه تفاوت نتیجه خروجی شاقول",
    "sections": [
      "تعریف ساده",
      "شاقول تشخیص",
      "مثال‌های واقعی",
      "اشتباه‌های رایج"
    ]
  },
  {
    "id": "create-goal",
    "type": "article",
    "title": "چگونه یک هدف نتیجه‌محور بسازیم؟",
    "summary": "هدف، مالک، بازه زمانی و شاخص‌های نتیجه را درست تعریف کنید.",
    "cat": "goals",
    "time": "۸ دقیقه",
    "level": "مقدماتی",
    "popular": 88,
    "updated": "۳ روز پیش",
    "keywords": "هدف ساخت هدف شاخص نتیجه مالک بازه زمانی kr",
    "sections": [
      "قبل از ساخت هدف",
      "تکمیل مشخصات",
      "افزودن شاخص نتیجه",
      "اتصال پروژه‌ها"
    ]
  },
  {
    "id": "update-goal",
    "type": "article",
    "title": "چرا باید اهداف را به‌روزرسانی کنیم؟",
    "summary": "ریتم مناسب به‌روزرسانی و ثبت وضعیت واقعی هدف را یاد بگیرید.",
    "cat": "goals",
    "time": "۴ دقیقه",
    "level": "میانی",
    "popular": 64,
    "updated": "هفته پیش",
    "keywords": "آپدیت بروزرسانی هدف درصد پیشرفت وضعیت",
    "sections": [
      "زمان به‌روزرسانی",
      "ثبت درصد پیشرفت",
      "نوشتن گزارش وضعیت"
    ]
  },
  {
    "id": "create-project",
    "type": "article",
    "title": "ساخت یک پروژه به‌صورت دستی",
    "summary": "پروژه جدید بسازید، مالک و مهلت تعیین کنید و اعضا را اضافه کنید.",
    "cat": "projects",
    "time": "۷ دقیقه",
    "level": "مقدماتی",
    "popular": 91,
    "updated": "دیروز",
    "keywords": "پروژه ساخت پروژه جدید مالک عضو مهلت",
    "sections": [
      "ورود به پروژه‌ها",
      "مشخصات پروژه",
      "افزودن اعضا",
      "ساخت اولین مایلستون"
    ]
  },
  {
    "id": "milestones",
    "type": "article",
    "title": "مایلستون‌ها را چطور تعریف کنیم؟",
    "summary": "پروژه را به خروجی‌های قابل تحویل و قابل سنجش تقسیم کنید.",
    "cat": "projects",
    "time": "۶ دقیقه",
    "level": "میانی",
    "popular": 72,
    "updated": "۵ روز پیش",
    "keywords": "مایلستون milestone نقطه عطف خروجی پروژه",
    "sections": [
      "مایلستون چیست",
      "نوشتن خروجی",
      "اتصال کارها",
      "تکمیل مایلستون"
    ]
  },
  {
    "id": "recurring-task",
    "type": "article",
    "title": "ساخت و مدیریت کار تکرارشونده",
    "summary": "تکرار روزانه یا دوره‌ای بسازید و اجرای یک نوبت را به تأخیر بیندازید.",
    "cat": "tasks",
    "time": "۹ دقیقه",
    "level": "میانی",
    "popular": 84,
    "updated": "امروز",
    "keywords": "تسک کار وظیفه تکرار روزانه دوره‌ای اجرای تاخیر",
    "sections": [
      "انتخاب الگوی تکرار",
      "ایجاد رخداد بعدی",
      "اجرای تأخیر",
      "توقف تکرار"
    ]
  },
  {
    "id": "today-focus",
    "type": "guide",
    "title": "انتخاب تمرکز امروز",
    "summary": "سه کار واقعی امروزتان را انتخاب کنید و از فهرست شلوغ فاصله بگیرید.",
    "cat": "tasks",
    "time": "۳ دقیقه",
    "level": "مقدماتی",
    "popular": 86,
    "updated": "امروز",
    "keywords": "تمرکز امروز اولویت کار مهم تسک",
    "sections": [
      "بازکردن تمرکز امروز",
      "انتخاب سه کار",
      "جابه‌جایی تمرکز"
    ]
  },
  {
    "id": "invite-members",
    "type": "article",
    "title": "دعوت عضو و تعیین نقش در فضای کاری",
    "summary": "اعضا را دعوت کنید و سطح دسترسی مناسب هر نفر را مشخص کنید.",
    "cat": "teams",
    "time": "۵ دقیقه",
    "level": "مقدماتی",
    "popular": 79,
    "updated": "هفته پیش",
    "keywords": "دعوت عضو کاربر نقش دسترسی مدیر",
    "sections": [
      "دعوت با شماره موبایل",
      "انتخاب نقش",
      "تغییر دسترسی",
      "لغو دعوت"
    ]
  },
  {
    "id": "remove-member",
    "type": "article",
    "title": "غیرفعال‌سازی یا حذف یک عضو",
    "summary": "تفاوت غیرفعال‌سازی و حذف و روش انتقال مسئولیت‌ها را ببینید.",
    "cat": "teams",
    "time": "۱۰ دقیقه",
    "level": "پیشرفته",
    "popular": 75,
    "updated": "دیروز",
    "keywords": "حذف کاربر عضو غیرفعال خروج انتقال مسئولیت",
    "sections": [
      "چه زمانی غیرفعال کنیم",
      "چه زمانی حذف کنیم",
      "انتقال مسئولیت‌ها",
      "اثر بر تاریخچه"
    ]
  },
  {
    "id": "share-in-chat",
    "type": "guide",
    "title": "اشتراک‌گذاری کار و پروژه در پیام‌ها",
    "summary": "بدون کپی‌کردن لینک، یک کار، هدف یا پروژه را داخل گفتگو بفرستید.",
    "cat": "messages",
    "time": "۳ دقیقه",
    "level": "مقدماتی",
    "popular": 82,
    "updated": "۴ روز پیش",
    "keywords": "پیام چت اشتراک گذاری کار هدف پروژه تیم",
    "sections": [
      "بازکردن ابزار اشتراک",
      "جست‌وجوی مورد",
      "ارسال در گفتگو"
    ]
  },
  {
    "id": "notification-settings",
    "type": "article",
    "title": "مدیریت اعلان‌ها",
    "summary": "مشخص کنید چه اعلان‌هایی، از چه مسیری و در چه زمانی دریافت شوند.",
    "cat": "settings",
    "time": "۵ دقیقه",
    "level": "مقدماتی",
    "popular": 60,
    "updated": "۲ هفته پیش",
    "keywords": "تنظیمات اعلان نوتیفیکیشن پیامک ایمیل",
    "sections": [
      "اعلان‌های داخل برنامه",
      "پیامک و ایمیل",
      "بی‌صداکردن موقت"
    ]
  },
  {
    "id": "subscription",
    "type": "article",
    "title": "خرید یا تمدید اشتراک",
    "summary": "پلن مناسب را انتخاب کنید و فرایند خرید یا تمدید را انجام دهید.",
    "cat": "settings",
    "time": "۶ دقیقه",
    "level": "مقدماتی",
    "popular": 66,
    "updated": "۳ روز پیش",
    "keywords": "اشتراک خرید پلن تمدید پرداخت فاکتور",
    "sections": [
      "مشاهده پلن‌ها",
      "انتخاب بازه",
      "پرداخت",
      "دریافت فاکتور"
    ]
  }
];

export const HELP_VIDEOS = [
  {
    "id": "video-first-workspace",
    "type": "video",
    "title": "شروع زوفینو در ۵ دقیقه",
    "summary": "از ثبت‌نام تا ساخت فضای کاری و دعوت اولین همکار.",
    "cat": "start",
    "duration": "۰۵:۱۸",
    "level": "مقدماتی",
    "popular": 99,
    "updated": "امروز",
    "keywords": "آموزش شروع ثبت نام فضای کاری دعوت عضو",
    "chapters": [
      [
        "ثبت‌نام",
        "۰۰:۰۰"
      ],
      [
        "ساخت فضای کاری",
        "۰۱:۱۲"
      ],
      [
        "دعوت اعضا",
        "۰۳:۲۵"
      ],
      [
        "اولین کار",
        "۰۴:۳۸"
      ]
    ],
    "related": "create-workspace"
  },
  {
    "id": "video-goal",
    "type": "video",
    "title": "ساخت اولین هدف و شاخص نتیجه",
    "summary": "یک هدف واقعی بسازید و پیشرفت آن را قابل سنجش کنید.",
    "cat": "goals",
    "duration": "۰۷:۴۲",
    "level": "مقدماتی",
    "popular": 93,
    "updated": "دیروز",
    "keywords": "ویدیو هدف شاخص نتیجه ساخت هدف",
    "chapters": [
      [
        "تعریف تغییر مطلوب",
        "۰۰:۰۰"
      ],
      [
        "ساخت هدف",
        "۰۱:۴۰"
      ],
      [
        "شاخص‌های نتیجه",
        "۰۳:۳۵"
      ],
      [
        "مالک و گزارش",
        "۰۶:۲۰"
      ]
    ],
    "related": "create-goal"
  },
  {
    "id": "video-project",
    "type": "video",
    "title": "ساخت پروژه، مایلستون و اولین کار",
    "summary": "ساختار یک پروژه واقعی را از ابتدا تا آماده اجرا ببینید.",
    "cat": "projects",
    "duration": "۰۹:۱۵",
    "level": "مقدماتی",
    "popular": 90,
    "updated": "۳ روز پیش",
    "keywords": "ویدیو پروژه مایلستون تسک ساخت",
    "chapters": [
      [
        "ساخت پروژه",
        "۰۰:۰۰"
      ],
      [
        "تعریف مایلستون",
        "۰۲:۲۵"
      ],
      [
        "افزودن کار",
        "۰۵:۱۰"
      ],
      [
        "نمای برد",
        "۰۷:۳۸"
      ]
    ],
    "related": "create-project"
  },
  {
    "id": "video-board",
    "type": "video",
    "title": "کار با برد کانبان پروژه",
    "summary": "کارها را بین «برای انجام»، «در حال انجام» و «انجام‌شده» جابه‌جا کنید.",
    "cat": "projects",
    "duration": "۰۶:۰۸",
    "level": "میانی",
    "popular": 81,
    "updated": "هفته پیش",
    "keywords": "برد کانبان todo doing done پروژه",
    "chapters": [
      [
        "نمای برد",
        "۰۰:۰۰"
      ],
      [
        "جابه‌جایی کار",
        "۰۱:۱۵"
      ],
      [
        "ساخت ستون",
        "۰۳:۴۰"
      ],
      [
        "فیلتر برد",
        "۰۵:۰۲"
      ]
    ],
    "related": "create-project"
  },
  {
    "id": "video-recurring",
    "type": "video",
    "title": "کار تکرارشونده و اجرای تأخیر",
    "summary": "منطق رخداد بعدی و تأخیر فقط در نوبت جاری را عملی ببینید.",
    "cat": "tasks",
    "duration": "۰۸:۳۶",
    "level": "میانی",
    "popular": 87,
    "updated": "امروز",
    "keywords": "ویدیو کار تکرار اجرای تاخیر روزانه",
    "chapters": [
      [
        "ساخت تکرار",
        "۰۰:۰۰"
      ],
      [
        "تکمیل نوبت جاری",
        "۰۲:۲۰"
      ],
      [
        "اجرای تأخیر",
        "۰۴:۴۵"
      ],
      [
        "ویرایش کل الگو",
        "۰۶:۳۷"
      ]
    ],
    "related": "recurring-task"
  },
  {
    "id": "video-team",
    "type": "video",
    "title": "دعوت اعضا و مدیریت دسترسی‌ها",
    "summary": "تفاوت مالک، مدیر و عضو را در یک سناریوی واقعی ببینید.",
    "cat": "teams",
    "duration": "۰۶:۵۲",
    "level": "مقدماتی",
    "popular": 76,
    "updated": "۵ روز پیش",
    "keywords": "عضو تیم دعوت نقش دسترسی ویدیو",
    "chapters": [
      [
        "دعوت عضو",
        "۰۰:۰۰"
      ],
      [
        "سطوح دسترسی",
        "۰۱:۳۴"
      ],
      [
        "تغییر نقش",
        "۰۴:۰۲"
      ],
      [
        "لغو دسترسی",
        "۰۵:۴۹"
      ]
    ],
    "related": "invite-members"
  },
  {
    "id": "video-chat",
    "type": "video",
    "title": "اشتراک‌گذاری اطلاعات در گفتگو",
    "summary": "کار، هدف، پروژه و تیم را مستقیماً داخل پیام به اشتراک بگذارید.",
    "cat": "messages",
    "duration": "۰۳:۴۴",
    "level": "مقدماتی",
    "popular": 83,
    "updated": "۴ روز پیش",
    "keywords": "پیام چت اشتراک اطلاعات کار هدف پروژه",
    "chapters": [
      [
        "شروع گفتگو",
        "۰۰:۰۰"
      ],
      [
        "انتخاب نوع اطلاعات",
        "۰۰:۵۸"
      ],
      [
        "جست‌وجو و ارسال",
        "۰۲:۱۰"
      ]
    ],
    "related": "share-in-chat"
  },
  {
    "id": "video-remove",
    "type": "video",
    "title": "خروج عضو و انتقال مسئولیت‌ها",
    "summary": "پیش از حذف همکار، تمام مسئولیت‌های باز او را کنترل و منتقل کنید.",
    "cat": "teams",
    "duration": "۱۱:۲۰",
    "level": "پیشرفته",
    "popular": 69,
    "updated": "دیروز",
    "keywords": "حذف عضو خروج انتقال مسئولیت پروژه هدف کار",
    "chapters": [
      [
        "غیرفعال یا حذف",
        "۰۰:۰۰"
      ],
      [
        "فهرست مسئولیت‌ها",
        "۰۲:۳۲"
      ],
      [
        "انتقال گروهی",
        "۰۵:۴۵"
      ],
      [
        "ثبت تاریخچه",
        "۰۹:۱۸"
      ]
    ],
    "related": "remove-member"
  },
  {
    "id": "video-subscription",
    "type": "video",
    "title": "خرید اشتراک زوفینو",
    "summary": "انتخاب پلن، بازه پرداخت و مشاهده فاکتور را مرحله‌به‌مرحله ببینید.",
    "cat": "settings",
    "duration": "۰۴:۲۹",
    "level": "مقدماتی",
    "popular": 63,
    "updated": "۲ روز پیش",
    "keywords": "ویدیو خرید اشتراک پلن پرداخت تمدید",
    "chapters": [
      [
        "ورود به اشتراک",
        "۰۰:۰۰"
      ],
      [
        "مقایسه پلن‌ها",
        "۰۰:۵۵"
      ],
      [
        "انتخاب بازه",
        "۰۲:۱۲"
      ],
      [
        "پرداخت",
        "۰۳:۰۸"
      ]
    ],
    "related": "subscription"
  }
];

export const HELP_TAG_MAP = {
  "start": [
    "شروع سریع",
    "فضای کاری",
    "تازه‌وارد"
  ],
  "goals": [
    "هدف‌گذاری",
    "شاخص نتیجه",
    "هم‌راستایی"
  ],
  "projects": [
    "مدیریت پروژه",
    "مایلستون",
    "برد"
  ],
  "tasks": [
    "کارها",
    "تمرکز",
    "تکرارشونده"
  ],
  "teams": [
    "اعضا",
    "دسترسی",
    "منابع انسانی"
  ],
  "messages": [
    "پیام",
    "همکاری",
    "اشتراک‌گذاری"
  ],
  "settings": [
    "تنظیمات",
    "اشتراک",
    "اعلان‌ها"
  ]
};

export const HELP_POPULAR_TAGS = ["شروع سریع","ساخت پروژه","هدف‌گذاری","کار تکرارشونده","دسترسی اعضا","اشتراک"];

// Display switches managed from the admin panel (مدیریت محتوی → تنظیمات نمایش).
export const HELP_SETTINGS = {popularArticles: true, newVideos: true, quickStart: true, updatedDate: true};

function replaceInPlace(target, next) {
    target.splice(0, target.length, ...next);
}

/**
 * Replaces the static content above with the content published from the admin panel
 * (GET /help-center/content). The arrays are mutated in place because the views import them directly.
 * Keeps the static content when the CMS has nothing published yet.
 */
export function applyRemoteHelpContent(data) {
    if (!data || !(data.articles?.length || data.videos?.length)) return;
    if (data.categories?.length) replaceInPlace(HELP_CATEGORIES, data.categories);
    replaceInPlace(HELP_ARTICLES, data.articles || []);
    replaceInPlace(HELP_VIDEOS, data.videos || []);
    if (data.popularTags?.length) replaceInPlace(HELP_POPULAR_TAGS, data.popularTags);
    Object.assign(HELP_SETTINGS, data.settings || {});
}
